 <template>
  <footer class="bg-gray-100 text-center p-4 mt-10">
    <p>&copy; 2025 KostKu. All rights reserved.</p>
  </footer>
</template>


<script>
export default {
    name: 'FooterView',

}
</script>

<style>

</style>